import React, { useContext } from 'react';

import { isTimelineHeatmapDef } from 'components/Studio/visTypes';

import CanvasCard from '../../Visualisations/CanvasCard';
import { ChartTopBar } from '../../Chart';
import DashboardGadgetBottomBar from '../../DashboardGadgetBottomBar';
import DashboardGadgetContext from '../../../contexts/DashboardGadgetContext';
import HeatmapContent from './HeatmapContent';
import HeatmapView from './HeatmapView';

const HeatmapContainer = ({
  chartDefinition,
  chartRef,
  useSmallNoDataMessage,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<any>;
  useSmallNoDataMessage: boolean;
}) => {
  const { dashboardGadget } = useContext(DashboardGadgetContext);

  return (
    <CanvasCard
      topBar={<ChartTopBar chartDefinition={chartDefinition} />}
      content={
        // A Timeline heatmap only Studio's ECharts renderer draws: it has
        // no second dimension to fetch the matrix by
        isTimelineHeatmapDef(chartDefinition) ? (
          <HeatmapView
            chartRef={chartRef}
            options={{}}
            isNoData
            useSmallNoDataMessage={useSmallNoDataMessage}
          />
        ) : (
          <HeatmapContent
            chartDefinition={chartDefinition}
            chartRef={chartRef}
            useSmallNoDataMessage={useSmallNoDataMessage}
          />
        )
      }
      bottomBar={dashboardGadget ? <DashboardGadgetBottomBar /> : undefined}
    />
  );
};

export default HeatmapContainer;
